/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Metadata_Empty_StateInputs */



/**
* | output |
* | --- |
* | "No metadata added yet. Add metadata information above to enhance your project." |
*
* @param {Options_Metadata_Empty_StateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_metadata_empty_state = /** @type {((inputs?: Options_Metadata_Empty_StateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Metadata_Empty_StateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune métadonnée ajoutée. Ajoutez des métadonnées ci-dessus pour enrichir votre projet.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Es wurden noch keine Metadaten hinzugefügt. Fügen Sie oben Metadaten hinzu, um Ihr Projekt zu verbessern.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun metadato ancora aggiunto. Aggiungi le informazioni sui metadati qui sopra per migliorare il tuo progetto.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Метаданные пока не добавлены. Добавьте информацию о метаданных выше, чтобы улучшить свой проект.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aún no se han añadido metadatos. Añade la información de metadatos arriba para mejorar tu proyecto.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("尚未添加元数据。请在上方添加元数据信息以完善您的项目。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メタデータがまだ追加されていません。プロジェクトを強化するには、上記のメタデータ情報を追加してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अभी तक कोई मेटाडेटा नहीं जोड़ा गया है। अपने प्रोजेक्ट को बेहतर बनाने के लिए ऊपर मेटाडेटा जानकारी जोड़ें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ainda não foram adicionados metadados. Adicione informações de metadados acima para aprimorar seu projeto.")
	return /** @type {LocalizedString} */ ("No metadata added yet. Add metadata information above to enhance your project.")
});